import { c as _c } from "react/compiler-runtime";
import { Col, Container, Row } from "react-bootstrap";
export default function AboutSubscriptions() {
  const $ = _c(22);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Row><Col><h1>Subscription Minting</h1></Col></Row>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="font-larger font-bolder">Overview</p>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <li className="mt-2">Subscription Minting is another way to mint Meme Cards<ul><li className="mt-1">With up to 98% significant gas savings and/or</li><li className="mt-1">While being away from your computer at the time of mint and/or</li><li className="mt-1">On a "set it and forget it" basis for whole SZNs</li></ul></li>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <li className="mt-2">Subscriptions are not a mintpass:<ul><li className="mt-1">You can decide to mint or not mint any specific Meme Card</li><li className="mt-1">Subscriptions respect the allowlist and phase process: A subscription only allows you to mint within the Phase you would otherwise be eligible for</li><li className="mt-1">It is better to think about subscriptions as "remote minting"</li></ul></li>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Row className="pt-2"><Col>{t1}<ul>{t2}{t3}<li className="mt-2">Subscriptions are not a replacement for the regular minting process:<ul><li className="mt-1">You can still mint in the normal manner if you don't subscribe</li><li className="mt-1">Subscriptions are an alternative method of minting for those who choose to use them</li></ul></li></ul></Col></Row>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <p className="font-larger font-bolder">How it Works</p>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <li className="mt-1">You can top up your minting balance at any time by sending ETH to: seize.6529.eth from any wallet of your consolidation</li>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <li className="mt-2">Fill Balance<ul>{t6}<li className="mt-1">Any amount sent to seize.6529.eth is{" "}<b>completely non-refundable</b>: you can choose which cards to mint but we do not have the capacity to send ETH back</li><li className="mt-1">The calculator on your profile will calculate the correct amount to send for any number of cards, with options for the remainder of the SZN and remainder of the year</li><li className="mt-1">The balance will appear on the site profile associated with the sending ETH address</li><li className="mt-1">Top ups must be received by 00:00 UTC (eg, 19:00 EST) the day before the Meme Card mint to be eligible for the mint; otherwise they will roll over to the next mint</li></ul></li>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <li className="mt-1">Automatic Mode: By default, you will auto-mint (get airdrop for) as many Meme Cards as you are eligible for, until your balance is used</li>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <li className="mt-2">Minting<ul>{t8}<li className="mt-1">You can choose to opt-out of any Meme Card mint:<ul><li className="mt-1">You must turn off minting for that specific drop before 00:00 UTC (eg, 19:00 EST) the day before the mint</li><li className="mt-1">The card reveal will move forward one day so that you can see the card before making a decision to mint it or not</li><li className="mt-1">This means that you can opt out on Sunday (for Monday's card), Tuesday (for Wednesday's card) and Thursday (for Friday's card)</li></ul></li><li className="mt-1">You can choose to move your whole profile to "manual" as opposed to "automatic": in this case, you will not mint any cards unless you manully opt-in to the specific cards you want to selectively mint</li></ul></li>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  let t11;
  let t12;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <li className="mt-1">Your card will be airdropped according on the following criteria:</li>;
    t11 = <li className="mt-1">If no delegation, to the primary address of a consolidation</li>;
    t12 = <li className="mt-1">If no consolidation, to the address you send the ETH from</li>;
    $[10] = t10;
    $[11] = t11;
    $[12] = t12;
  } else {
    t10 = $[10];
    t11 = $[11];
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <li className="mt-1">If there is a delegation, in this order:<ul><li className="mt-1">The delegated address for The Memes for use case "Airdrop"</li><li className="mt-1">The delegated address for The Memes for use case "All"</li><li className="mt-1">The delegated address for Any Collection for use case "Airdrop"</li><li className="mt-1">The delegated address for Any Collection for use case "All"</li></ul></li>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <li className="mt-2">Delegation<ul>{t10}{t11}{t12}{t13}<li className="mt-1">If you have the suggested TAP configuration with a vault/warm/hot consolidation with your vault delegating ALL to warm or hot, and you would like your airdrops directly to your vault, we recommend:<ul><li className="mt-1">sending ETH to seize.6529.eth from warm or hot address</li><li className="mt-1">adding delegation use-case "Airdrop" for the "The Memes" from that address to your vault</li></ul></li><li className="mt-1">If you have a single address (not consolidated) that has delegated "All" to a minting address and you want to send ETH from the original address and have the airdrop received by that same address, then you should change your delegation to "Minting" otherwise the airdrop will go to your minting address</li></ul></li>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  let t16;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <li className="mt-1">Subscription Minting respects the same Allowlist and Phases as regular minting</li>;
    t16 = <li className="mt-1">If you are in Phase 0, subscription minting will automatically airdrop you the card at the beginning of Phase 0: since Phase 0 is underallocated, you are guaranteed a mint</li>;
    $[15] = t15;
    $[16] = t16;
  } else {
    t15 = $[15];
    t16 = $[16];
  }
  let t17;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Row className="pt-3"><Col>{t5}<ul>{t7}{t9}{t14}<li className="mt-2">Allowlists and Phases<ul>{t15}{t16}<li className="mt-1">If you are eligible for Phase 1 or Phase 2, you will be airdropped the card at the beginning of Phase 1 or Phase 2<ul><li className="mt-1">In the event that no cards are available to mint in that phase, you will not be airdropped the card and your balance will remain available</li><li className="mt-1">In the event that at the beginning of a Phase, there are more subscription mints than available cards, the cards will be airdropped in order of when the subscription payment was received</li></ul></li><li className="mt-1">As with regular minting methods, you are only guaranteed a mint in Phase 0</li><li className="mt-1">For popular mints, your opportunity will be determined by your phase, how many other subscription mints are in place for that mint, and when you subscribed relative to other subscribers</li></ul></li></ul></Col></Row>;
    $[17] = t17;
  } else {
    t17 = $[17];
  }
  let t18;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <p className="font-larger font-bolder">Gas Savings</p>;
    $[18] = t18;
  } else {
    t18 = $[18];
  }
  let t19;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <li className="mt-2">Meme Cards are relatively inexpensive (0.06529 ETH) so in periods of high Ethereum gas, minting costs can become a substantial % of the card's cost<ul><li className="mt-1">At gwei of 20, they make up 3.4% of the card's cost</li><li className="mt-1">At gwei of 200, they make up 33.7% of the card's cost</li></ul></li>;
    $[19] = t19;
  } else {
    t19 = $[19];
  }
  let t20;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Row className="pt-3"><Col>{t18}<ul>{t19}<li className="mt-2">ETH transfers are the lowest cost transaction on the Ethereum network<ul><li className="mt-1">Someone who subscription-mints 1 card at a time will save approximately 80% in gas costs</li><li className="mt-1">Someone who subscription-mints 10 cards at a time (with one ETH transfer) will save approximately 98% in gas costs</li></ul></li><li className="mt-2">The Memes will absorb the gas cost of the airdrop internally, so it will not be charged to the collector</li></ul></Col></Row>;
    $[20] = t20;
  } else {
    t20 = $[20];
  }
  let t21;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Container>{t0}{t4}{t17}{t20}<Row className="pt-3"><Col><p className="font-larger font-bolder">Remote Minting</p><ul><li className="mt-2">Many collectors have busy schedules and may not be able to be available three times per week at the time of the mint, due to personal or professional commitments</li><li className="mt-2">Subscription minting allows them to separate the decision of if they should mint a series of Meme Cards or a specific Meme Card from the specific time of the mint</li><li className="mt-2">This is a benefit to all collectors, but especially to those who live in time zones that do not overlap well with the minting time</li></ul></Col></Row></Container>;
    $[21] = t21;
  } else {
    t21 = $[21];
  }
  return t21;
}